import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { updateOpportunity } from '../opportunities'

export default function useOpportunityUpdate() {
  const queryClient = useQueryClient()

  const { mutate, isLoading } = useMutation(updateOpportunity, {
    onSuccess: () => {
      queryClient.invalidateQueries(`opportunities`)
      notification.success({
        message: 'Sucesso!',
        description: 'Atualização realizada com sucesso!'
      })
    },
    onError: () => {
      notification.error({
        message: 'Erro',
        description: 'Não foi possível atualizar!'
      })
    }
  })

  return { mutate, isLoading }
}
